import styled, { css } from 'styled-components';
import { hasGutterValue, widthCalculator, gutterFunction, offsetCalculator } from '../utilities';

var createBreakpoints = function createBreakpoints(props) {
  var columnBreakpoints = props.columnBreakpoints,
      gutterValue = props.gutterValue,
      gutterSize = props.gutterSize;
  return columnBreakpoints.map(function (column) {
    var hasColumnGutterValue = hasGutterValue(column.gutterValue);
    return (column.columns || column.offset || hasColumnGutterValue) && css(["@media screen and (min-width:", "){", " ", " margin-left:", ";", "}"], props.theme.size.breakpoint['min-width'][column.breakpoint], widthCalculator(props.numberOfColumns, column.columns, hasColumnGutterValue ? column.gutterValue : gutterValue, gutterSize), column.offset && offsetCalculator(props, column.offset, gutterSize), hasColumnGutterValue && gutterFunction(column.gutterValue, props.gutterSize), column.gutterValue === -1 ? css(["margin-right:", ";"], gutterFunction(column.gutterValue, props.gutterSize)) : hasColumnGutterValue && css(["margin-right:0;"]));
  });
};

var GridColumn = styled.div.withConfig({
  displayName: "Columnstyles__GridColumn",
  componentId: "gzwgdw-0"
})(["", ""], function (props) {
  return css(["flex:1;margin-left:", ";", " ", ";"], gutterFunction(props.gutterValue, props.gutterSize), props.gutterValue === -1 && css(["margin-right:", ";"], gutterFunction(props.gutterValue, props.gutterSize)), createBreakpoints(props));
});
export { GridColumn };